import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from 'lazy-route';

const videoRoutes = [
  <Route
    key="video-watch"
    exact
    path="/video/watch"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/pages/Video")}
      />
    )}
  />,
  <Route
    key="video-trial"
    exact
    path="/video/trial"
    render={(props) => (
      <LazyRoute
        {...props}
        component={import("src/components/video/Trial")}
      />
    )}
  />
];

export default videoRoutes; 